"use strict";
/* global WorkerGlobalScope */
module.exports =
    typeof window === 'undefined' &&
        !(typeof WorkerGlobalScope !== 'undefined' &&
            self instanceof WorkerGlobalScope);
